module.exports = __webpack_public_path__ + "static/media/aquablue.cad29e22.png";